import NoAccessOverlayStats from './NoAccessOverlayStats';

export default NoAccessOverlayStats;
